module.exports = __webpack_public_path__ + "static/media/arya_event.ecee851b.png";